import React from 'react';
import '../assets/styles/Pricing.css';
import { useNavigate } from 'react-router-dom';

const PricingCard = ({ plan, price, interval }) => {
  const navigate = useNavigate();

  return (
    <div className="ft-pricing-card">
      <h2 className="ft-pricing-plan-title">{plan}</h2>
      <div className="ft-pricing-price">
        ${price}
        <span className="ft-pricing-interval">/{interval}</span>
      </div>
      <ul className="ft-pricing-features">
        <li>• ALL FEATURES INCLUDED</li>
      </ul>
      <button className="ft-pricing-purchase-button" onClick={() => navigate('/signup')}>
        Purchase
      </button>
    </div>
  );
};

const PricingComponent = () => (
  <div className="ft-pricing-container">
    <h1 className="ft-pricing-title">Pricing</h1>
    <div className="ft-pricing-cards">
      <PricingCard plan="Monthly" price="4.99" interval="month" />
      <PricingCard plan="Yearly" price="49.99" interval="year" />
    </div>
  </div>
);

export default PricingComponent;
